import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorBrandSettingsCard from '../MotorBrandSettingsCard';
import { useLanguage } from '../../../../i18n/LanguageContext';

const STOR_EXTRA_KEYS = [
  'jumbo',
  'altEtekDilim',
  'kapaliKasa',
  'altEtekLazer',
  'dekoratifLama',
  'dekoratifKasa',
  'altEtekBeyazIs',
];

const ZEBRA_EXTRA_KEYS = [
  'jumbo',
  'altEtekDilim',
  'kapaliKasa',
];

const StorZebraSettings = React.memo(({
  extraPrices,
  setExtraPrices,
  handleSaveSettings,
  isSavingSettings,
  activeTypeTab
}) => {
  const { t } = useLanguage();
  const isStor = activeTypeTab === 'stor';
  const extraKeys = isStor ? STOR_EXTRA_KEYS : ZEBRA_EXTRA_KEYS;

  const motorTitle = isStor
    ? t('productList.extraPrices.storMotorTitle', 'Stor Motor ve Kumanda Ayarları')
    : t('productList.extraPrices.zebraMotorTitle', 'Zebra Motor ve Kumanda Ayarları');

  const motorSubtitle = isStor
    ? t('productList.extraPrices.storMotorSubtitle', 'Stor siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri')
    : t('productList.extraPrices.zebraMotorSubtitle', 'Zebra siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri');

  const cardTitle = isStor
    ? t('productList.extraPrices.storTitle', 'Stor Perde Ücret Ayarları')
    : t('productList.extraPrices.zebraTitle', 'Zebra Perde Ücret Ayarları');

  const cardSubtitle = isStor
    ? t('productList.extraPrices.storSubtitle', 'Stor siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri')
    : t('productList.extraPrices.zebraSubtitle', 'Zebra siparişlerinde kullanılacak sistem ve aksesuar ek ücretleri');

  return (
    <>
      <MotorBrandSettingsCard
        title={motorTitle}
        subtitle={motorSubtitle}
        productType={activeTypeTab}
        extras={extraPrices}
        setExtras={setExtraPrices}
        handleSaveSettings={handleSaveSettings}
        isSavingSettings={isSavingSettings}
      />

      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className={isStor ? 'fas fa-cog' : 'fas fa-stream'}></i>
            <div className="settings-card-title-text">
              <h4>{cardTitle}</h4>
              <span className="settings-card-subtitle">
                {cardSubtitle}
              </span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid">
          {extraKeys.map((key) => (
            <div className="form-group" key={key}>
              <label>{t(`productList.extraFields.${key}`, key)}</label>
              <div className="settings-input-wrap">
                <input
                  type="number"
                  value={extraPrices[key]}
                  onChange={(e) => setExtraPrices(p => ({ ...p, [key]: e.target.value }))}
                  placeholder="0"
                />
                <span className="settings-input-suffix">€</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
});

export default StorZebraSettings;
